import React from 'react';
import { Redirect, Route, Switch } from 'react-router';
import { useSelector } from 'react-redux';
import Login from './Auth/Login';
import ApplicationLayout from 'Layouts/ApplicationLayout';
import Error404 from './Pages/404/Error404';
import AuthenticateToken from './Auth/AuthenticateToken';
import SearchResults from './Pages/SearchResults/SearchResults';
import { homePage } from 'config/config';

const RestrictedRoute = ({ component: Component, ...rest }) => {
  const accountReducer = useSelector(state => state.AccountReducer);

  return (
    <Route
      {...rest}
      render={props =>
        accountReducer.isLoggedIn ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: '/signin',
              search: `?returnUrl=${window.location.pathname}`,
            }}
          />
        )
      }
    />
  );
};

const Routes = () => {
  return (
    <React.Fragment>
      <Switch>
        <Route path="/" exact>
          <Redirect to={homePage} />
        </Route>
        <Route path="/signed-in" component={AuthenticateToken} />
        <Route path="/signin" component={Login} />
        <RestrictedRoute path="/dealer" component={ApplicationLayout} />
        <Route path="/search" component={SearchResults} />
        <Route component={Error404} />
      </Switch>
    </React.Fragment>
  );
};

export default Routes;
